const PROD_API_BASE_URL = "https://admin-laravel.washywash.com/api";
const LOCAL_API_BASE_URL = "http://127.0.0.1:8000/api";

const apiTarget = (process.env.REACT_APP_API_TARGET || "prod").trim().toLowerCase();

const config = {
  apiBaseUrl:
    apiTarget === "local"
      ? process.env.REACT_APP_API_BASE_URL_LOCAL || LOCAL_API_BASE_URL
      : process.env.REACT_APP_API_BASE_URL || PROD_API_BASE_URL,
  imageBaseUrl: process.env.REACT_APP_IMG_BASE_URL || 'https://storage-washywash.s3.eu-central-1.amazonaws.com/image/',
};

export default config;
